import { useCallback, useState, FocusEventHandler, ChangeEventHandler } from 'react';

export const useFocus = <T extends HTMLInputElement | HTMLTextAreaElement = HTMLInputElement>(
    onChange: (value: string) => void,
    onFocus: FocusEventHandler<T> | undefined,
    onBlur: FocusEventHandler<T> | undefined
): {
    changeHandler: ChangeEventHandler<T>;
    focusHandler: FocusEventHandler<T>;
    blurHandler: FocusEventHandler<T>;
    isFocused: boolean;
} => {
    const [isFocused, setFocused] = useState(false);

    const changeHandler = useCallback<ChangeEventHandler<T>>(
        (event) => {
            onChange(event.target.value);
        },
        [onChange]
    );

    const focusHandler = useCallback<FocusEventHandler<T>>(
        (event) => {
            setFocused(true);
            onFocus?.(event);
        },
        [setFocused, onFocus]
    );

    const blurHandler = useCallback<FocusEventHandler<T>>(
        (event) => {
            setFocused(false);
            onBlur?.(event);
        },
        [setFocused, onBlur]
    );

    return { changeHandler, focusHandler, blurHandler, isFocused };
};
